// Libraries
var React = require("react");
var utilGuid = require('../../common/utilGuid.js');

// Style
require("./MultiSelect.scss");

class MultiSelectModule extends React.Component {
  constructor(props) {

    super(props);

    this.state = {
      items: this.props.data,
      expanded: false,
      guid: utilGuid.guid()
    }

    this.onGlobalClick = this.globalClickEvents.bind(this);

  }

  componentDidMount() {

    if (typeof window === 'undefined') {

      return;

    }

    document.addEventListener('click', this.onGlobalClick);
    
  }

  globalClickEvents(event) {
    if(event.target.classList.contains('js-multi-select-label')) {
      this.setState({ expanded: !this.state.expanded });
    } else if (!event.target.closest('.c-multi-select') && this.state.expanded) {
      this.setState({ expanded: false });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.onGlobalClick);
}

  calculateItemsSelected(items) {

    let count = 0;
    for (let i = 0; i < items.length; i++) { if (items[i].selected) { count++; } }
    return count;

  }

  handleChange(index) {

    this.props.parentCallback(index);

  }

  handleToggle() {

    let expanded = this.state.expanded;
    this.setState({ expanded: !expanded });

  }

  buttonText() {
    const numberOfItemsSelected = this.calculateItemsSelected(this.props.data);

    if(!numberOfItemsSelected && this.props.noneSelectedText) {
      return this.props.noneSelectedText;
    }
    else {
      return `${numberOfItemsSelected} ${this.props.selectedOptionsText ? this.props.selectedOptionsText : "option"}${numberOfItemsSelected !== 1 ? "s" : ""} selected`;
    }

  }

  render() {
    const guid = this.state.guid;
    return (
      <div id={this.props.data.id} className={`c-multi-select${this.props.data.isPremium ? " c-multi-select--premium" : ""}`}>
        <button type="button" aria-controls={`multi-select-${guid}`} aria-expanded={this.state.expanded} aria-label="Toggle multi-select" className="c-multi-select__toggle" onClick={this.handleToggle.bind(this)}>
          <span className="c-multi-select__toggle__inner">{this.buttonText()}</span>
        </button>
        <div className={`c-multi-select__list-wrapper${this.state.expanded ? " c-multi-select__list-wrapper--visible" : ""}`} id={`multi-select-${guid}`}>
          <ul className="c-multi-select__list">
            {this.props.data.map((item, index) => {
              return (
                <li className="c-multi-select__item" key={index}>
                  <input type="checkbox" value={item.value} id={`${item.value}-${guid}`} checked={item.selected} onChange={this.handleChange.bind(this, index)} />
                  <label htmlFor={`${item.value}-${guid}`}>{item.text}</label>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    );
  }
}

module.exports = MultiSelectModule;



// WEBPACK FOOTER //
// ./src/components/MultiSelect/MultiSelect.js